import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'exam-result'
const Actions = crudActions(endpoint)

const create = (_, examResult) => {
  const formData = new FormData()
  formData.append('apply_doc', examResult.apply_doc)
  formData.append('exam', examResult.exam)
  formData.append('direction_mark', examResult.direction_mark ? examResult.direction_mark : 0)
  formData.append('english_mark', examResult.english_mark ? examResult.english_mark : 0)
  formData.append('is_certificate', examResult.is_certificate)
  if (examResult.base64) formData.append('exam_ans_file', examResult.base64)
  formData.append('is_accepted', examResult.is_accepted)
  if (examResult.advisor) formData.append('advisor', examResult.advisor)
  if (examResult.scientific_work_name) formData.append('scientific_work_name', examResult.scientific_work_name)
  return axios.post(`/${endpoint}/`, formData)
}

const addAdditional = (ctx, data) => axios.patch(`/${endpoint}/${data.id}/`)
const removeAdditional = (ctx, data) => axios.patch(`/${endpoint}/${data.id}/change_to_failed_apply_doc/`)

export default {
  ...Actions,
  create,
  addAdditional,
  removeAdditional,
}
